export const FORM_NAME = 'Insurance';
